require('angular');

angular.module('app').config(function ($provide, $httpProvider) {
    var mode        = 'test';
    var projectDir  = 'kd'
    var protocol    = 'https'

    // Intercept http calls.
    $provide.factory('httpInterceptor', function ($q) {
        return {

            redirect: function (slug) {
                window.location.href = window.location.protocol.replace(/:/g,'') + "://" + window.location.host + '/' + slug;
            },

            // On request success
            request: function (config) {
                return config || $q.when(config);
            },

            // On request failure
            requestError: function (rejection) {
                // Return the promise rejection.
                return $q.reject(rejection);
            },

            // On response success
            response: function (response) {
                // Return the response or promise.
                return response || $q.when(response);
            },

            // On response failture
            responseError: function (rejection) {
                // Return the promise rejection.
                return $q.reject(rejection);
            }
        };
    });

    // Add the interceptor to the $httpProvider.
    $httpProvider.interceptors.push('httpInterceptor');

});